import { createReducer } from '@reduxjs/toolkit';
import { setCanvasPreviewSize, setZoomLevel } from './actions';
import { PreviewState } from './types';
import getPredefinedPreviewTargetByName from './utils/getPredefinedPreviewTargetByName';

const initialPreviewTarget = getPredefinedPreviewTargetByName('Fullscreen');
const initialState: PreviewState = {
  zoomLevel: 100,
  size: {
    name: initialPreviewTarget.name,
    width: initialPreviewTarget.width,
  },
};

const previewReducer = createReducer(initialState, (builder) => {
  /**
   * Change the canvas preview size
   */
  builder.addCase(setCanvasPreviewSize, (state, action) => {
    const size = action.payload;
    state.size = size;
  });
  /**
   * Change the zoom level.
   */
  builder.addCase(setZoomLevel, (state, action) => {
    const zoomLevel = action.payload;
    state.zoomLevel = zoomLevel;
  });
});

export default previewReducer;
